import {
  Component,
  ChangeDetectionStrategy,
  ElementRef,
} from '@angular/core';

/** @see https://www.figma.com/file/yqBeq1MiGfpdN62SvmA8tg/RTLABS_GAS_DS_1?node-id=589%3A5592 */
@Component({
  // eslint-disable-next-line
  selector: 'div[gasInputError]',
  templateUrl: './gas-input-error.component.html',
  styleUrls: ['./gas-input-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasInputErrorComponent {
  constructor(
    public elementRef: ElementRef,
  ) {}
}
